import React from 'react'

import { PanelContainer } from '../../../../components/Panel'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { useConfigContext } from '../../../ui-config'
import { useDeliveryForecastItemById } from '../../data'
import { DeliveryScheduleDetailsForm } from './DeliveryScheduleDetails.form'
import { ForecastsTable, PreviousDeliveriesTable, SplitsTable } from './Tables'

type Props = {
  deliveryForecastId: string
  itemId: string
  isConfirmationActive: boolean
}

export const DeliveryScheduleDetailsView: React.FC<Props> = ({
  deliveryForecastId,
  itemId,
  isConfirmationActive,
}) => {
  const { uiConfig: config } = useConfigContext()
  const { data: deliveryForecastItem, isLoading } = useDeliveryForecastItemById(
    deliveryForecastId,
    itemId,
  )

  return (
    <PanelContainer
      header={getConfigTranslation(
        config.deliveryForecast.deliveryScheduleDetails.title,
      )}
      id="delivery-call-offs-delivery-schedule-details"
      visible={config.deliveryForecast.deliveryScheduleDetails.enabled}
    >
      <>
        <DeliveryScheduleDetailsForm
          deliveryForecastId={deliveryForecastId}
          itemId={itemId}
        />

        <PreviousDeliveriesTable
          items={deliveryForecastItem?.PreviousDeliveries}
          isLoading={isLoading}
        />

        <SplitsTable
          deliveryForecastId={deliveryForecastId}
          itemId={itemId}
          isLoading={isLoading}
          isConfirmationActive={isConfirmationActive}
          unit={deliveryForecastItem?.Unit}
          iconOnly={true}
        />

        <ForecastsTable
          items={deliveryForecastItem?.Forecasts}
          isLoading={isLoading}
        />
      </>
    </PanelContainer>
  )
}
